import { render, staticRenderFns } from "./DeleteBrokerAccount.vue?vue&type=template&id=249d739c&scoped=true"
import script from "./DeleteBrokerAccount.vue?vue&type=script&lang=js"
export * from "./DeleteBrokerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249d739c",
  null
  
)

export default component.exports